import { render, staticRenderFns } from "./QuoteRowActions.vue?vue&type=template&id=96ed0878&"
import script from "./QuoteRowActions.vue?vue&type=script&lang=js&"
export * from "./QuoteRowActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports